import React, { useState } from 'react';
import { AppstoreOutlined, MailOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Outlet, Link, useSearchParams, useNavigate } from "react-router-dom";
import { Menu, Row, Col, Avatar } from 'antd';

const FeedBackTab = () => {
    const [selecte_keys, setSelectedKeys] = useState(window.location.pathname);
    const navigate = useNavigate();
    const titles = {
        '/cramSchool/admin/Form': '系統意見回饋表單',
        '/cramSchool/admin/FormList': '系統意見回饋表單列表',
    }
    const item = [
        {
            key: "/cramSchool/admin/Form",
            label: `系統意見回饋表單`,
        },
        {
            key: "/cramSchool/admin/FormList",
            label: '系統意見回饋表單列表',
        },]
    const onSelect = (e) => {
        navigate(e.key)
        document.title = titles[e.key]
        setSelectedKeys([e.key])
    }
    return (
        <>
            <Menu
                onSelect={onSelect}
                selectedKeys={selecte_keys}
                mode="horizontal"
                items={item}
            // style={{ position: 'relative', display: 'flex', justifyContent: 'center' }} 
            />
            {/* <div style={{ minHeight: '60vh' }}>
                <Outlet />
            </div> */}
        </>
    )

};
export default FeedBackTab;